import * as React from 'react'
import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { SolidPlay } from '@factorialco/f0-react/icons/app'
import { CanSeeBlackFridayPromoDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import oneIconPromo from 'modules/marketplace_modules/lib/one-icon-promo.png'
import oneIcon from 'modules/marketplace_modules/lib/one-icon.png'
import { isValidModule } from 'modules/marketplace_modules/lib/typesValidation'
import CheckoutModal from 'modules/upsell/components/SelfUpsell/CheckoutModal'

import OneVideoModal from './_OneVideoModal'

type TextColor = React.ComponentProps<typeof Text.Normal>['color']

interface BannerConfig {
  bgStyle: {
    background: string
    borderBottom: string
    padding: string
    gap: string
  }
  textColor: TextColor
  title: string
  subtitle: string
  image: string
  buttonBg?: string
}

const OneBanner = ({
  chargebeeModuleName,
  moduleName,
}: {
  chargebeeModuleName: string
  moduleName?: string
}) => {
  const [isCheckoutModalOpen, setIsCheckoutModalOpen] = useState(false)
  const [isOneVideoOpen, setIsOneVideoOpen] = useState(false)

  const { data } = useQuery(CanSeeBlackFridayPromoDocument)
  const isBlackFridayPromoEnabled = data?.upsell._policies.canSeeBlackFridayPromo.can

  const blackFridayPromo: BannerConfig = {
    bgStyle: {
      background: 'linear-gradient(120deg, #0c0c14 0%, #2e3a45 40%, #5a3a44 70%, #793341 100%)',
      borderBottom: '1px solid #262626',
      padding: '12px 18px',
      gap: '10px',
    },
    textColor: 'white',
    title: i18n.t('marketplace.black_friday_promo.one_banner.title'),
    subtitle: i18n.t('marketplace.black_friday_promo.one_banner.description', {
      module: moduleName,
    }),
    image: oneIconPromo,
    buttonBg: 'white',
  }

  const defaultTexts: BannerConfig = {
    bgStyle: {
      background:
        'linear-gradient(270deg, rgba(161, 173, 229, 0.05) 0%, rgba(229, 25, 67, 0.05) 50%, rgba(229, 86, 25, 0.05) 100%)',
      borderBottom: '1px solid #f1f1f1',
      padding: '12px 18px',
      gap: '10px',
    },
    textColor: 'grey1000',
    title: i18n.t('marketplace.revamp.one_banner.title'),
    subtitle: i18n.t('marketplace.revamp.one_banner.description', {
      module: moduleName,
    }),
    image: oneIcon,
  }

  const currentBanner = isBlackFridayPromoEnabled ? blackFridayPromo : defaultTexts

  return (
    <>
      <div className="py-2 px-4">
        <Box
          flexDirection="row"
          justifyContent="spaceBetween"
          flexWrap="wrap"
          gap="s8"
          style={currentBanner.bgStyle}
        >
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Box width="s40" height="s40">
              <img src={currentBanner.image} alt="One Icon" />
            </Box>
            <Box flexDirection="column" gap="s2">
              <Text.Normal weight="medium" color={currentBanner.textColor}>
                {currentBanner.title}
              </Text.Normal>
              <Text.Normal size="200" color={currentBanner.textColor}>
                {currentBanner.subtitle}
              </Text.Normal>
            </Box>
          </Box>
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Box
              style={{
                color: currentBanner.buttonBg || '',
              }}
            >
              <F0Button
                variant="primary"
                size="md"
                onClick={() => {
                  setIsOneVideoOpen(true)
                }}
                label={i18n.t('marketplace.revamp.one_banner.discover_button')}
                icon={SolidPlay}
              />
            </Box>
            <Box
              style={{
                background: 'white',
                borderRadius: '10px',
              }}
            >
              <F0Button
                variant="outline"
                size="md"
                onClick={() => {
                  setIsCheckoutModalOpen(true)
                }}
                label={i18n.t('marketplace.revamp.one_banner.button')}
              />
            </Box>
          </Box>
        </Box>
      </div>

      {isValidModule(chargebeeModuleName) && chargebeeModuleName && (
        <CheckoutModal
          isOpen={isCheckoutModalOpen}
          onClose={() => setIsCheckoutModalOpen(false)}
          moduleName={chargebeeModuleName}
          from={'one_banner'}
        />
      )}

      <OneVideoModal isOpen={isOneVideoOpen} onClose={() => setIsOneVideoOpen(false)} />
    </>
  )
}

export default OneBanner
